import React from "react";
import './HeroTech.css';
import Moribe from "../img/moribe.png";
import Sakurai from "../img/Sakurai.png";
import T from "../img/T.png";
import MTG from "../img/MTG.png";
import strategy from "../img/strategy.png";
import K from "../img/K.png";

const HeroTech = () => {
    return (
        <section className="hero-tech">
            <div className="hero-tech-decorations">
                <div className="tech-circle tech-circle-1"></div>
                <div className="tech-circle tech-circle-2"></div>
                <div className="tech-circle tech-circle-3"></div>
            </div>

            <div className="hero-tech-container">

                {/* セクションヘッダー */}
                <div className="hero-tech-header">
                    <h2 className="hero-tech-title">
                        ｜地域で信頼される存在 × 成果を出す広告技術
                    </h2>
                    <p className="hero-tech-subtitle">
                        金沢エリアに精通した公的機関コーディネーターと<br />東京で培われた広告運用のプロフェッショナルが
                        あなたのビジネスを本気でサポートします。
                    </p>
                </div>

                {/* プロフィールカード */}
                <div className="profile-cards">

                    {/* 守部氏プロフィール */}
                    <div className="profile-card profile-card-morube">
                        {/* 写真エリア（カード上部を大きく占める） */}
                        <div className="profile-photo-area">
                            <div className="profile-role-vertical">地域密着コーディネーター</div>
                            <img src={Moribe} alt="守部 和孝" className="profile-photo-img" />
                        </div>

                        {/* 番号 + 名前バー */}
                        <div className="profile-namebar profile-namebar-blue">
                            <span className="profile-name">守部 和孝</span>
                        </div>

                        {/* 情報エリア（カード下部・白背景） */}
                        <div className="profile-info-area">
                            <div className="profile-credentials">
                                <div className="credential-item">
                                    <span className="credential-icon">▶</span>
                                    <span>石川県を拠点に3社を経営</span>
                                </div>
                                <div className="credential-item">
                                    <span className="credential-icon">▶</span>
                                    <span>公的機関での中小企業IT支援経験</span>
                                </div>
                                <div className="credential-item">
                                    <span className="credential-icon">▶</span>
                                    <span>多業種のWeb集客支援実績</span>
                                </div>
                            </div>

                            <p className="profile-description">
                            石川県を拠点に複数の事業を経営しながら、中小企業のIT活用・売上拡大・マーケティング支援に携わる事業家。これまで飲食店・治療院・サロン・士業など多くの企業の<strong>ネットで集客する仕組みづくり</strong>をサポート。ITの知識だけでなく、経営者としての実体験をもとに売上につながる戦略を提案できることが強みです。
                            </p>

                            <div className="profile-strength profile-strength-blue">
                                <h5>強み</h5>
                                <ul>
                                    <li>金沢エリアの<strong>企業事情を理解した戦略設計と現地訪問対応可能</strong></li>
                                    <li>公的機関での企業支援経験による<strong>高い信頼性</strong></li>
                                    <li>IT×経営の両面からの<strong>実践的かつ戦略的マーケティング支援</strong></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* 桜井氏プロフィール */}
                    <div className="profile-card profile-card-sakurai">
                        {/* 写真エリア */}
                        <div className="profile-photo-area">
                            <div className="profile-role-vertical">広告運用スペシャリスト</div>
                            <img src={Sakurai} alt="桜井 佳佑" className="profile-photo-img" />
                        </div>

                        {/* 番号 + 名前バー */}
                        <div className="profile-namebar profile-namebar-orange">
                            <span className="profile-name">桜井 佳佑</span>
                        </div>

                        {/* 情報エリア */}
                        <div className="profile-info-area">
                            <div className="profile-credentials">
                                <div className="credential-item">
                                    <span className="credential-icon">▶</span>
                                    <span>各種Google広告認定資格保有</span>
                                </div>
                                <div className="credential-item">
                                    <span className="credential-icon">▶</span>
                                    <span>東京IT企業でWebデザイン / マーケティング従事実績</span>
                                </div>
                                <div className="credential-item">
                                    <span className="credential-icon">▶</span>
                                    <span>企業SNSの運用経験有</span>
                                </div>
                            </div>

                            <p className="profile-description">
                            東京のIT企業でWebデザイン・マーケティングを担当し、広告運用・LP設計・データ分析まで幅広く経験。新規飲食店の開業マーケティングや大規模イベントの集客プロジェクトなど、成果を求められる現場で広告運用を実践。金沢エリアの企業にも首都圏レベルの広告運用ノウハウを提供します。
                            </p>

                            <div className="profile-strength profile-strength-orange">
                                <h5>強み</h5>
                                <ul>
                                    <li><strong>Google広告認定資格</strong>による確かな知識力と技術力</li>
                                    <li>首都圏で培った<strong>最新の広告運用ノウハウ</strong></li>
                                    <li>データドリブン/<strong>PDCA運用</strong></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>{/* /.profile-cards */}

                {/* 体制の強み */}
                <div className="team-strength">
                    <h3 className="team-strength-title">この体制だからこそ実現できること</h3>
                    <div className="strength-grid">
                        <div className="strength-item">
                            <div className="strength-icon"><img src={T} /></div>
                            <h4>地域密着 × 専門技術</h4>
                            <p>地域の課題を理解し、東京レベルの広告運用技術で解決します。</p>
                        </div>
                        <div className="strength-item">
                            <div className="strength-icon"><img src={MTG} /></div>
                            <h4>現地訪問 × オンライン</h4>
                            <p>金沢エリアなら現地訪問も可能。対面とオンラインを使い分けた柔軟な支援体制。</p>
                        </div>
                        <div className="strength-item">
                            <div className="strength-icon"><img src={strategy} /></div>
                            <h4>戦略設計 × 運用実行</h4>
                            <p>経営視点での戦略立案から、実務レベルの広告運用まで一気通貫でサポート。</p>
                        </div>
                        <div className="strength-item">
                            <div className="strength-icon"><img src={K} /></div>
                            <h4>公的信頼 × 実績</h4>
                            <p>よろず支援拠点の信頼性と、実際の広告運用実績の両立。安心してお任せください。</p>
                        </div>
                    </div>
                </div>

                {/* CTA */}
                <div className="hero-tech-cta">
                    <p className="cta-text">まずは無料相談で、あなたのビジネスの課題をお聞かせください。</p>
                    <button className="cta-button" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                        無料で相談する
                        <span className="button-arrow">→</span>
                    </button>
                </div>

            </div>
        </section>
    );
};

export default HeroTech;